import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { EstampService } from 'src/app/services/estamp.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { TableColumn } from '../data-table/data-table.component';


@Component({
    selector: 'app-article-code-list',
    templateUrl: './article-code-list.component.html',
    styleUrls: ['./article-code-list.component.scss'],
    standalone: false
})
export class ArticleCodeListComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'id', header: 'Id' },
    { field: 'article_name', header: 'Article Name' },
    { field: 'article_code', header: 'Article Code' },
  ];

  states: any;
  articles: any = [];
  stateSelected: any;
  stateData: any;
  searchForm: FormGroup;
  fileUrl: string;
  constructor(private router: Router, private fb: FormBuilder,
    private storageService: StorageService,
    private userDashboardService: UserDashboardService,
    private estampService: EstampService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef) {
    this.stateSelected = this.storageService.getState() || null;
   
    this.getArticles(this.stateSelected.state_code);
    this.getStateDetails();
    this.searchForm = this.fb.group({
      search: [''] // Initial value for the search input
    });
  }

  ngOnInit(): void {
  }
  getArticles(id) {
    let queryParams = { state_code: id };
    this.estampService.getArticles(queryParams).subscribe((resp) => {
      if (resp.status) {
        this.articles = resp['content'];
        this.cdr.detectChanges();
      }
    });
  }
  get searchControl() {
    return this.searchForm.get('search');
  }
  onStateChange() {
   
    this.getArticles(this.stateSelected.state_code);
  }
  filterArticles() {
  
    const searchTerm = this.searchControl.value.toLowerCase();
   
    if (searchTerm !== '') {
      this.articles = this.articles.filter(article =>
        article.article_name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.getArticles(this.stateSelected.state_code);
    }

  }

  getStateDetails() {
    this.userDashboardService.getStates().subscribe((res: any) => {
      this.stateData = res['content'];
      this.cdr.detectChanges();
    });
  }

  getKarnatakaArticlesDetails() {
    this.fileUrl = "assets/utils/KA_list_of_articles_280224.pdf";
    this.downExcelSample(this.fileUrl, 'KA_list_of_articles')
  }

  downExcelSample(fileUrl: any, fileName: any) {
    this.http.get(fileUrl, { responseType: 'blob' }).subscribe((response: Blob) => {
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(response);
      downloadLink.download = fileName;
      downloadLink.click();
    });
  }

}
